import { render, staticRenderFns } from "./media_snap_save_as_dialog.vue?vue&type=template&id=4b799b22&scoped=true"
import script from "./media_snap_save_as_dialog.vue?vue&type=script&lang=js"
export * from "./media_snap_save_as_dialog.vue?vue&type=script&lang=js"
import style0 from "./media_snap_save_as_dialog.vue?vue&type=style&index=0&id=4b799b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b799b22",
  null
  
)

export default component.exports